import { useMemo } from "react";
import { StyleSheet } from "react-native";

import { useTheme } from "../ThemeProvider";
import { DialogSize } from "./DialogTypes";

export function useDialogStyles(size: DialogSize = DialogSize.md) {
  const theme = useTheme();

  return useMemo(
    () =>
      StyleSheet.create({
        dialogContainer: {
          backgroundColor: theme.colors.background,
          borderRadius: theme.borderRadius.lg,
          maxHeight: "80%",
          width: "100%",
          maxWidth: size,
          flexDirection: "column",
          flexShrink: 1,
          paddingBottom: theme.spacing.s2,
          overflow: "hidden",
        },
        contentContainer: {
          flexGrow: 1,
          justifyContent: "center",
          alignItems: "center",
          padding: theme.spacing.s5,
        },
        imageContainer: {
          width: "100%",
          marginBottom: theme.spacing.s5,
        },
        textContainer: {
          alignItems: "center",
          paddingHorizontal: theme.spacing.s3,
        },
        title: {
          alignSelf: "center",
          textAlign: "center",
        },
        subtitle: {
          textAlign: "center",
        },
        buttonContainer: {
          flexDirection: "column",
          justifyContent: "center",
          padding: theme.spacing.s4,
          gap: theme.spacing.s2,
        },
        header: {
          padding: theme.spacing.s2,
        },
      }),
    [theme, size],
  );
}
